import { useOutletContext } from 'react-router-dom'

import type { ListId, FormState, List } from '@/main/features/List/listSlice'

export function useListOutletContext() {
  return useOutletContext<{ id: ListId; form: FormState | undefined; list: List }>()
}
